/**
 * @author Eric Otto
 */

module.exports = {

    menu: document.querySelector('#menu'),
    burger: document.querySelector('#burger'),
    body: document.querySelector('body'),

    init: function () {
        'use strict';

        const that = this,
            button = document.getElementById('mobile-nav-button');

        button.addEventListener('click', function () {
            if (that.menu.className === 'mobile-menu') {
                that.openNav();
            } else {
                that.closeNav();
            }
        });
    },

    openNav: function () {
        'use strict';

        this.body.classList.add('animation-stop');
        this.menu.classList.add('mobile-menu--open');
        this.burger.classList.add('mobile-nav-button__lines--opened');
    },
    closeNav: function () {
        'use strict';

        this.menu.className = 'mobile-menu';
        this.burger.className = 'mobile-nav-button__lines';
        this.body.classList.remove('animation-stop');
    }
};
